import type { ReactNode } from 'react';
import styled from 'styled-components';

export const FeedbackWrapper = styled.section`
  max-width: 1200px;
  padding: 0 24px;

  @media ${({ theme }) => theme.media.desktop} {
    padding: 0 40px;
  }
`;

export const FeedbackGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;

  @media ${({ theme }) => theme.media.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FeedbackCard = styled.div<{ children: ReactNode }>`
  background-color: white;
  border-radius: 8px;
  padding: 32px;
  border: 1px solid ${({ theme }) => theme.palette.lightGray};
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 8px;
`;

export const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserName = styled.span`
  font-weight: 600;
  font-size: 20px
  color: #333;
`;

export const FeedbackText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  margin: 0;
`;

export const Rating = styled.div`
  color: #ffd700;
  font-size: 16px;
  margin-bottom: 16px;
`;
